import createFetchDuck from '../../util/genericEntityDuck';

export const storeKey = 'flowSummary';
const duck = createFetchDuck('HEARTBEAT', storeKey, 'flowAccessId', 'heartbeat');

export default duck;
export const { creators, reducer, types, selectors } = duck;
